import React from 'react';

interface Props {
  className?: string;
}

const DrawCircle: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="20"
    viewBox="0 0 20 21"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer 2">
      <g id="Layer 3">
        <path
          d="M10 9.5C10.1978 9.5 10.3911 9.55865 10.5556 9.66853C10.72 9.77841 10.8482 9.93459 10.9239 10.1173C10.9996 10.3 11.0194 10.5011 10.9808 10.6951C10.9422 10.8891 10.847 11.0673 10.7071 11.2071C10.5673 11.347 10.3891 11.4422 10.1951 11.4808C10.0011 11.5194 9.80004 11.4996 9.61732 11.4239C9.43459 11.3482 9.27841 11.22 9.16853 11.0556C9.05865 10.8911 9 10.6978 9 10.5C9 10.2348 9.10536 9.98043 9.29289 9.79289C9.48043 9.60536 9.73478 9.5 10 9.5ZM10 8C9.50555 8 9.0222 8.14662 8.61108 8.42133C8.19995 8.69603 7.87952 9.08648 7.6903 9.54329C7.50108 10.0001 7.45157 10.5028 7.54804 10.9877C7.6445 11.4727 7.8826 11.9181 8.23223 12.2678C8.58187 12.6174 9.02732 12.8555 9.51228 12.952C9.99723 13.0484 10.4999 12.9989 10.9567 12.8097C11.4135 12.6205 11.804 12.3 12.0787 11.8889C12.3534 11.4778 12.5 10.9945 12.5 10.5C12.5 9.83696 12.2366 9.20107 11.7678 8.73223C11.2989 8.26339 10.663 8 10 8Z"
          fill="currentColor"
          id="Vector"
        />
        <path
          d="M10 3C11.4834 3 12.9334 3.43987 14.1668 4.26398C15.4002 5.08809 16.3614 6.25943 16.9291 7.62987C17.4968 9.00032 17.6453 10.5083 17.3559 11.9632C17.0665 13.418 16.3522 14.7544 15.3033 15.8033C14.2544 16.8522 12.918 17.5665 11.4632 17.8559C10.0083 18.1453 8.50032 17.9968 7.12988 17.4291C5.75943 16.8614 4.58809 15.9001 3.76398 14.6668C2.93987 13.4334 2.5 11.9834 2.5 10.5C2.5 8.51088 3.29018 6.60322 4.6967 5.1967C6.10323 3.79018 8.01088 3 10 3ZM10 0.5C8.02219 0.5 6.08879 1.08649 4.4443 2.1853C2.79981 3.28412 1.51809 4.8459 0.761209 6.67317C0.00433284 8.50043 -0.193701 10.5111 0.192152 12.4509C0.578004 14.3907 1.53041 16.1725 2.92894 17.5711C4.32746 18.9696 6.10929 19.922 8.0491 20.3079C9.98891 20.6937 11.9996 20.4957 13.8268 19.7388C15.6541 18.9819 17.2159 17.7002 18.3147 16.0557C19.4135 14.4112 20 12.4778 20 10.5C20 7.84784 18.9464 5.3043 17.0711 3.42893C15.1957 1.55357 12.6522 0.5 10 0.5Z"
          fill="currentColor"
          id="Vector_2"
        />
      </g>
    </g>
  </svg>
);

export default DrawCircle;
